import React from 'react';

export interface TooltipData {
  readonly dimensionValue: string;
  readonly measureValue: number;
  readonly dimensionLabel: string;
  readonly measureLabel: string;
  readonly x: number;
  readonly y: number;
}

interface ChartTooltipProps {
  readonly tooltip: TooltipData | null;
}

/**
 * Positioned tooltip overlay for chart elements.
 * Shows exact dimension and measure values on hover/focus.
 */
export function ChartTooltip({ tooltip }: ChartTooltipProps): React.ReactElement | null {
  if (!tooltip) {
    return null;
  }

  return (
    <div
      role="tooltip"
      className="pointer-events-none absolute z-50 rounded border border-border bg-popover px-3 py-2 text-sm text-popover-foreground shadow-md"
      style={{
        left: tooltip.x,
        top: tooltip.y,
        transform: 'translate(-50%, -100%)',
        marginTop: -8,
      }}
    >
      <div className="font-medium">{tooltip.dimensionLabel}: {tooltip.dimensionValue}</div>
      <div>{tooltip.measureLabel}: {tooltip.measureValue.toLocaleString()}</div>
    </div>
  );
}
